import { Tabs, Tab, Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

export const NavBarRelatoriosFinanceiro = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    navigate(newValue);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
      <Tabs
        value={location.pathname}
        onChange={handleChange}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="CONTAS A RECEBER" value="/relatoriofinanceiro/rreceber" />
        <Tab label="CONTAS RECEBIDAS" value="/relatoriofinanceiro/rrecebidas" />
        <Tab label="CONTAS A PAGAR" value="/relatoriofinanceiro/rpagar" />
        <Tab label="CONTAS PAGAS" value="/relatoriofinanceiro/rpagas" />
      </Tabs>
    </Box>
  );
};